export const getCookie = (key: string) => {
  const val = new RegExp(String.raw`(^|;)\s*${key}\s*=\s*([^;]+)`).exec(document.cookie);
  return val ? val.pop() : "";
};
